module.exports = __webpack_public_path__ + "static/media/oppo-indonesia-8.6fb5d49e.jpg";